import { trackApplicationEvent } from 'tracking/application/trackApplicationEvent';

export const trackRTRStart = trackApplicationEvent('REALTIME_ANALYSIS_START');
export const trackRTRApproval = trackApplicationEvent('REALTIME_ANALYSIS_APPROVED');
export const trackRTRDenial = trackApplicationEvent('REALTIME_ANALYSIS_CHECK_EMAIL');
export const trackRTRAppStoreClick = trackApplicationEvent('REALTIME_ANALYSIS_APPSTORE_CLICK');
